import { useSyncExternalStore } from 'react';
import { saved } from '../saved.ts';
import { Notice } from './ui.tsx';

const nothing = () => null;

/**
 * The portal's one notice that a change landed, mounted once in App, over every page (Jason, 2026-10-07: "something
 * pop up that says updated or save that is clear"): api.ts tells src/saved.ts after each change the API accepts, with
 * its words or none (`noticeWords`), and this draws it. It is never in a report's picture of the screen.
 */
export function SavedNotice() {
  const state = useSyncExternalStore(saved.subscribe, saved.current, nothing);
  return <Notice words={state?.words ?? null} shown={state?.on ?? false} data-feedback-ui />;
}
